module.exports = __webpack_public_path__ + "img/cq5.8883fa2c.jpg";